module.exports = __webpack_public_path__ + "static/media/logo-gov.1f5736f5.svg";